import React from "react"
import _ from "lodash"
import Box from "@material-ui/core/Box"
import PropTypes from "prop-types"
import Typography from "@material-ui/core/Typography"
import useStyles from "../fundsStyle"
import useSmartFormat from "../../../i18n/useSmartFormat"
import { words } from "../../../i18n/lstrings"

function extractRawNumber(item) {
  if (_.isUndefined(item) || _.isUndefined(item.filter)) {
    return undefined
  }

  const { filter } = item
  if (_.isNumber(filter)) {
    return filter
  }

  if (_.isObject(filter)) {
    return filter.amount
  }

  return undefined
}

function rowAdapter(fundKey, columns, row) {
  return columns.map((col) => {
    const item = row[col.dataIndex]
    const raw = extractRawNumber(item)
    return {
      key: `${item.text}_${col.dataIndex}`,
      raw,
      text: item.text,
      subText: `(${col.text})`
    }
  })
}

function extraClass(props, cls) {
  if (!props || !cls) {
    return null
  }
  const { raw } = props
  if (raw === undefined || !_.isNumber(raw)) {
    return null
  }

  if (raw > 0) {
    return cls.perfInfoBoxGreen
  }

  if (raw < 0) {
    return cls.perfInfoBoxRed
  }

  return null
}

function PerfInfoBox(props) {
  const classes = useStyles()
  const { text, subText } = props
  const extra = extraClass(props, classes)
  return (
    <Box className={classes.perfInfoBox}>
      <Typography className={`${classes.perfInfoBoxText} ${extra}`}>
        {text}
      </Typography>
      <Typography className={classes.perfInfoBoxCaption}>{subText}</Typography>
    </Box>
  )
}

PerfInfoBox.propTypes = {
  text: PropTypes.string,
  subText: PropTypes.string
}

PerfInfoBox.defaultProps = {
  text: undefined,
  subText: undefined
}

export default function FundKPIs(props) {
  const { columns, data } = props
  const classes = useStyles()
  const format = useSmartFormat()

  // data is array coressponding to view model
  // it is suppose to have only one row at this level
  // because, it has been process for ONE selected FUND
  if (_.isEmpty(columns) || _.isEmpty(data)) {
    return <Box>{format(words.noData)}</Box>
  }

  // convert an Object into a rows
  const currentRowArr = rowAdapter(null, columns, _.first(data))

  //
  return (
    <Box className={classes.perfInfoBoxContainer}>
      {_.map(currentRowArr, (rowProps) => (
        <PerfInfoBox {...rowProps} />
      ))}
    </Box>
  )
}

FundKPIs.propTypes = {
  columns: PropTypes.array.isRequired,
  data: PropTypes.array.isRequired
}
